
import { computed, defineComponent } from 'vue';
import messagesStore, { ClientMessageEx } from '@/core/messages/messages.store';
import { ClientMessageType } from '@/b2b/shared/api/server-apis';
import dictionaryService from '@/core/dictionary/dictionary.service';

export default defineComponent({
    name: 'ApiMessages',
    setup() {
        const apiMessages = computed(() => {
            return messagesStore.apiMessages;
        });

        const clearApiMessage = (id: string): void => {
            messagesStore.clearApiMessage(id);
        };

        const getMessage = (msg: unknown): string => {
            return msg.labelKey ? dictionaryService.get(msg.labelKey) : msg.message || dictionaryService.get('global/generic/unexpectedServerError');
        };

        const backgroundClass = (msg: ClientMessageEx) => {
            return {
                'bg-roman': msg.messageType === ClientMessageType.Error,
                'bg-gainsboro-grey': msg.messageType === ClientMessageType.Warning || !msg.messageType,
                'bg-brandy': msg.messageType === ClientMessageType.Info,
            };
        };

        return {
            apiMessages,
            backgroundClass,
            clearApiMessage,
            getMessage,
        };
    },
});
